import on from 'dom-event'
import select from 'select-dom'
import { formatPrice, findElementAsync } from '@/js/lib/util'
import { STEP_LABEL_MAPPING } from '@modules/quiz/quiz-data.js'

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(attachProductItemsViewedEvent, 1500)
})

const getProductData = ({ product, activeVariant }) => {
  if (!product) return

  let selectedVariant = null
  if (typeof activeVariant === 'string' || activeVariant instanceof String) {
    selectedVariant = JSON.parse(activeVariant)
  } else if (activeVariant) {
    selectedVariant = activeVariant
  }

  const productData = {
    item_id: product.id,
    item_name: product.title.replace("'", ''),
    item_brand: product.vendor,
    item_category: product.productType || product.type,
    price: selectedVariant ? formatPrice(selectedVariant.price).toString() : formatPrice(product.price).toString(),
    variant_item_id: selectedVariant ? selectedVariant.sku : (product.firstAvailableVariant ? product.firstAvailableVariant.sku : product.variants[0].sku),
    product_badge: product.badgeText || ''
  }

  if (product.index) productData['index'] = parseInt(product.index)

  if (product.affiliation) {
    productData['affiliation'] = product.affiliation
  }

  if (product.variantTitle) {
    productData['variant'] = product.variantTitle === 'Default Title' ? 'Single' : product.variantTitle
  }

  if (product.variantItemId) {
    productData['variant_item_id'] = product.variantItemId
  }

  return productData
}

const getProductCartData = (product) => {
  if (!product) return

  const productData = {
    item_id: product.product_id ? product.product_id : product.id,
    item_name: product.product_title ? product.product_title.replace("'", '') : product.title.replace("'", ''),
    item_brand: product.vendor,
    item_category: product.product_type,
    price: formatPrice(product.price).toString(),
    variant: product.variant_title === 'Default Title' ? 'Single' : product.variant_title,
    variant_item_id: product.sku,
    quantity: product.quantity || 1,
    product_badge: product.properties?._badgeText || product.badgeText || ''
  }

  if (product.affiliation) {
    productData['affiliation'] = product.affiliation
  }

  return productData
}

export const fetchProductGtm = (productHandle, i, itemsVariantId) => {
  return new Promise((resolve) => {
    if (!productHandle || !productHandle.length) resolve(null)

    let url = `${Shopify.routes.root}products/${productHandle}?view=ajax-gtm`
    if (itemsVariantId.length && itemsVariantId[i]) {
      url = `${Shopify.routes.root}products/${productHandle}?view=ajax-gtm&variant=${itemsVariantId[i]}`
    }

    window.fetch(url)
      .then(res => res.json())
      .then(data => {
        resolve(data)
      })
      .catch(() => {
        resolve(null)
      })
  })
}

export const affiliation = (item) => {
  if (!item.properties || !item.properties._bundleLabel) return  'A la Carte'
  if (item.properties._bundleLabel === '16 Meals') return 'Build Your Box, 16 Count Meals Subscription'
  if (item.properties._bundleLabel === '24 Meals') return 'Build Your Box, 24 Count Meals Subscription'
  if (item.properties._bundleLabel === '16 Pouches') return 'Build Your Box, 16 Count Pouch Subscription'
  if (item.properties._bundleLabel === '24 Pouches') return 'Build Your Box, 24 Count Pouch Subscription'
  if (item.properties._bundleLabel === '32 Pouches') return 'Build You Box, 32 Count Pouch Subscription'
  if (item.properties._bundleLabel === '32 Mixed') return 'Mixed Bundle, 32 Count Subscription'
  if (item.properties._bundleLabel === '40 Pouches') return 'Build You Box, 40 Count Pouch Subscription'
  if (item.properties._bundleLabel === '40 Mixed items' || item.properties._bundleLabel === '40 Mixed' ) return 'Mixed Bundle, 40 Count Subscription'

  return  'A la Carte'
}

const getProductCartSubcriptionData = (product) => {
  if (!product) return

  const storageBundle = localStorage.getItem('onceuponafarm-bundle-subscriptions')
  const bundleParse = storageBundle ? JSON.parse(storageBundle) : {}
  const bundleData = bundleParse[product.properties?._bundleHandle]
    ? bundleParse[product.properties?._bundleHandle].products.filter(item => item.item_id === product.product_id)
    : []

  const itemId = bundleParse[product.properties?._bundleHandle]?.id || null

  const productData = {
    index: product.index,
    item_id: product.product_id,
    item_name: product.title.replace("'", ''),
    item_brand: product.vendor,
    item_category: product.product_type,
    price: formatPrice(product.price).toString(),
    quantity: product.quantity,
    variant_item_id: product.sku,
    product_badge: product.properties._badgeText || '',
    affiliation: affiliation(product)
  }

  if (product.variant_options.length) {
    productData['variant'] = product.variant_options[0]
  }

  if (product.selling_plan_allocation) {
    productData['delivery_frequency'] = product.selling_plan_allocation.selling_plan.name.trim()
  }

  if (bundleData.length > 0) {
    productData['index'] = bundleData[0].index
    productData['variant'] = bundleData[0].variant
    productData['product_badge'] = bundleData[0].product_badge
  }

  if (itemId) {
    productData['item_id'] = parseInt(itemId)
  }

  return productData
}

export const pushOnQuizLinksClick = () => {
  const quizLinkEls = select.all('a[href*="/pages/quiz"]')
  quizLinkEls.forEach((el) => {
    on(el, 'click', (e) => {
      e.preventDefault()

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'ce_quiz_click',
        eventCategory: 'quiz',
        eventAction: 'click',
        eventLabel: 'homepage',
        eventValue: ''
      })

      window.location.href = el.pathname
    })
  })
}

export const pushOnQuizStarted = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ce_quiz_started',
    eventCategory: 'quiz',
    eventAction: 'view',
    eventLabel: 'Quiz Started',
    eventValue: ''
  })
}

export const pushOnQuizEmailSubmitted = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ce_quiz_email',
    eventCategory: 'quiz',
    eventAction: 'submit',
    eventLabel: 'Quiz Email Submitted',
    eventValue: ''
  })
}

export const pushOnQuizQuestionView = (questionId) => {
  const eventLabel = STEP_LABEL_MAPPING[questionId]
  if (!eventLabel) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ce_quiz_question',
    eventCategory: 'quiz',
    eventAction: 'view',
    eventLabel,
    eventValue: ''
  })
}

export const pushOnQuizChoice = (eventLabel) => {
  if (!eventLabel || !eventLabel.length) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ce_quiz_choice',
    eventCategory: 'quiz',
    eventAction: 'click',
    eventLabel,
    eventValue: ''
  })
}

export const pushOnQuizCompleted = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ce_quiz_completed',
    eventCategory: 'quiz',
    eventAction: 'view',
    eventLabel: 'Quiz Completed',
    eventValue: ''
  })
}

export const pushOnQuizRecommended = (eventLabel, eventValue) => {
  if (!eventLabel || !eventLabel.length) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ce_quiz_recommended',
    eventCategory: 'quiz',
    eventAction: 'recommendation',
    eventLabel,
    eventValue
  })
}

export const pushOnQuizAddToCart = (eventLabel, eventValue) => {
  if (!eventLabel || !eventLabel.length) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ce_quiz_add_to_cart',
    eventCategory: 'quiz',
    eventAction: 'click',
    eventLabel,
    eventValue
  })
}

export const pushOnQuizCheckout = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ce_quiz_checkout',
    eventCategory: 'quiz',
    eventAction: 'click',
    eventLabel: 'Quiz Checkout Started',
    eventValue: ''
  })
}

export const pushOnQuizRetake = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ce_quiz_retake',
    eventCategory: 'quiz',
    eventAction: 'click',
    eventLabel: 'Quiz Retake Started',
    eventValue: ''
  })
}

export const pushOnQuizAge = (age) => {
  if (!age) return
  let eventLabel = 'LT6M'

  if (age === '12-17 Months') {
    eventLabel = '6T17M'
  }

  if (age === '18+ Months') {
    eventLabel = 'GT18M'
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ce_quiz_journey',
    eventCategory: 'quiz',
    eventAction: 'journey',
    eventLabel: eventLabel,
    eventValue: ''
  })
}

export function pushSelectProductItem (product, collection) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ ecommerce: null })

  const items = [{
    item_id: product.id,
    item_name: product.title.replace("'", ''),
    index: product.index,
    item_brand: product.vendor,
    item_category: product.productType,
    product_badge: product.badgeText || ''
  }]

  window.dataLayer.push({
    event: 'select_item',
    item_list_name: collection,
    ecommerce: {
      items: items
    }
  })
}

export function datalayerViewItem (product, activeVariant) {
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      currency: Shopify.currency.active,
      value: formatPrice(activeVariant ? activeVariant.price : product.price).toString(),
      items: [].concat(getProductData({ product, activeVariant }))
    }
  })
}

export function pushViewItemListToDataLayer (viewItemList, location) {
  if (!viewItemList || !viewItemList.length) return
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "view_item_list",
    item_list_name: location || '',
    ecommerce: {
      items: viewItemList.map(item => {
        const newItem = { ...item }
        delete newItem.location
        return newItem
      })
    }
  });
}

export function handleViewItemListDatalayer (data, location) {
  if(!data) return
  const listId = data.map(item => item.item_id)
  const sessionData = JSON.parse(sessionStorage.getItem('data-layer')) || []
  const sameIds = listId.length === sessionData.length && listId.every(function (value, index) { return value === sessionData[index]})
  if (!sameIds) {
    const viewItemList = data.filter(item => sessionData.indexOf(item.item_id) === -1)
    pushViewItemListToDataLayer(viewItemList, location)
    sessionStorage.setItem('data-layer', JSON.stringify(listId))
  }
}

export function viewCartDataLayer () {
  window.fetch(`/cart?view=ajax`)
    .then(response => response.json())
    .then(data => {
      if (!data.cartItem.length) {
        return
      }

      window.dataLayer = window.dataLayer || []
      let cartItem = data.cartItem.map(item => {
        if (!item.bundle_handle) return item
        const storageBundle = localStorage.getItem('onceuponafarm-bundle-subscriptions')
        const bundleParse = storageBundle ? JSON.parse(storageBundle) : {}
        const bundleData = bundleParse[item.bundle_handle]
          ? bundleParse[item.bundle_handle].products.filter(product => product.item_id === item.item_id)
          : []

        const itemId = bundleParse[item.bundle_handle]?.id || null

        const newItem = { ...item }
        if (bundleData.length > 0) {
          newItem['index'] = bundleData[0].index
        }

        if (itemId) {
          newItem['item_id'] = parseInt(itemId)
        }

        delete newItem.bundle_handle
        return newItem
      })
      dataLayer.push({
        event: 'view_cart',
        ecommerce: {
          currency: Shopify.currency.active,
          value: data.cartTotalPrice,
          items: cartItem
        }
      })
    })
    .catch(error => {
      console.log(error)
    })
}

export function datalayerAddToCard (product) {
  const quantity = product.quantity || 1
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: Shopify.currency.active,
      value: formatPrice(product.price * quantity).toString(),
      items: [].concat(getProductCartData(product))
    }
  })
}

export function datalayerAddToCardSubscription (products) {
  let allPrice = 0
  let items = []
  products.map((product, index) => {
    allPrice += (product.price * product.quantity)
    items.push(getProductCartSubcriptionData({...product, index: index + 1}))
  })
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: Shopify.currency.active,
      value: formatPrice(allPrice).toString(),
      items: items
    }
  })
}

export const handleRemoveLineItem = (totalPrice, items) => {
  if (!items || !items.length) return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: "remove_from_cart",
    ecommerce: {
      currency: Shopify.currency.active,
      value: totalPrice,
      items: items
    }
  })
}

export const getDeliveryFrequencyProductBundle = (productBundle) => {
  if (!productBundle) return ''
  const search = window.location.search
  const searchParams = new URLSearchParams(search)
  const sellingPlan = searchParams.get('selling_plan')
  const sellingPlanGroups = productBundle && (productBundle.selling_plan_group || productBundle.selling_plan_groups.length) ? productBundle.selling_plan_groups[0].selling_plans.find(item => item.id === Number(sellingPlan)) : false
  if (!sellingPlanGroups) return sellingPlanGroups
  return sellingPlanGroups.name
}

export const getAffiliationProductBundle = (productBundle) => {
  const variant = productBundle && productBundle.variants ? productBundle.variants[0] : false
  if (!variant) return 'A la Carte'
  if (variant.public_title === '16 Meals') return 'Build Your Box, 16 Count Meals Subscription'
  if (variant.public_title === '24 Meals') return 'Build Your Box, 24 Count Meals Subscription'
  if (variant.public_title === '16 Pouches') return 'Build Your Box, 16 Count Pouch Subscription'
  if (variant.public_title === '24 Pouches') return 'Build Your Box, 24 Count Pouch Subscription'
  if (variant.public_title === '32 Pouches') return 'Build You Box, 32 Count Pouch Subscription'
  if (variant.public_title === '40 Pouches') return 'Build You Box, 40 Count Pouch Subscription'
  if (variant.public_title === '32 Mixed') return 'Mixed Bundle, 32 Count Subscription'
  if (variant.public_title === '40 Mixed items' || variant.public_title === '40 Mixed') return 'Mixed Bundle, 40 Count Subscription'
  return 'A la Carte'
}

export const getProductBundleData = async (itemsListHandle, itemsVariantId) => {
  if (!itemsListHandle || !itemsListHandle.length) return
  const items = await Promise.all(itemsListHandle.map((handle, i) => fetchProductGtm(handle, i, itemsVariantId)))

  const productBundle = window.reactInit.productBundle
  const products = items && items.map((item, i) => {
    const dataObject = {
      ...item,
      variant: 'Single',
      index: i + 1,
      affiliation: getAffiliationProductBundle(productBundle),
      delivery_frequency: (getDeliveryFrequencyProductBundle(productBundle) || "").toString().trim()
    }
    delete dataObject.Handle

    return dataObject
  })

  localStorage.setItem('onceuponafarm-bundle-subscriptions', JSON.stringify({
    ...localStorage.getItem('onceuponafarm-bundle-subscriptions') ? JSON.parse(localStorage.getItem('onceuponafarm-bundle-subscriptions')) : {},
    [window.reactInit.bundle.Handle]: {
      id: window.reactInit.bundle.ProductId.replace('gid://shopify/Product/', ''),
      products
    }
  }))

  const productsWithBundleId = products.map((product) => {
    return {
      ...product,
      item_id: productBundle.id
    }
  })

  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      items: productsWithBundleId
    }
  })
}

let itemsListAll = []
export const onProductIntersectionObserved = (products) => {
  let itemsListHandle = []
  let itemsVariantId = []
  const productsInfo = window.reactInit ? window.reactInit.productsInfo : false
  const bundleData = productsInfo && productsInfo.length ? productsInfo : products
  if (!bundleData) return
  const productItemEls = select.all('[data-testid="product-card"]')

  productItemEls && productItemEls.forEach((el, index) => {
    const variantId = el.dataset.pid
    let productHandle = bundleData.filter(item => item?.Variants?.find(variant => variant?.VariantId?.includes(variantId)))
    if (productHandle.length) {
      productHandle = productHandle[0].Handle
    }
    if (products && products.length) {
      productHandle = bundleData[index] ? bundleData[index].Handle : ''
    }
    el.setAttribute('data-handle', productHandle)
    if (!itemsListAll.includes(productHandle)) {
      itemsListAll.push(productHandle)
      itemsListHandle.push(productHandle)
      itemsVariantId.push(variantId)
    }
    handleProductCardTitle(el)
  })

  setTimeout(() => {
    getProductBundleData(itemsListHandle, itemsVariantId)
  }, 300)
}

export const handleProductCardTitle = (el) => {
  const productTitle = el.querySelector('.bundle-product-card__title')
  if (!productTitle) return
  productTitle.removeAttribute('role')
}

export const attachProductItemsViewedEvent = async () => {
  const productsInfo = window.reactInit?.productsInfo || []

  let productsInCollection = []

  if (Array.isArray(window.reactInit?.productsInCollection) && window.reactInit.productsInCollection.length) {
    productsInCollection = window.reactInit.productsInCollection
  }

  if (Array.isArray(window.reactInit?.productsInSections) && window.reactInit.productsInSections.length) {
    productsInCollection = window.reactInit.productsInSections.map(item => Array.isArray(item.products) ? [...item.products] : []).flat()
  }

  if (Array.isArray(window.reactInit?.productsInfo) && window.reactInit.productsInfo.length) {
    productsInCollection = window.reactInit.productsInfo
  }

  const bundleData = productsInfo.length ? productsInfo : productsInCollection

  if (!bundleData.length) return

  if (productsInCollection.length) {
    onProductIntersectionObserved(productsInCollection)
  }

  const bundleSectionEl = await findElementAsync('[data-testid="product-card"]')
  if (!bundleSectionEl) return

  onProductIntersectionObserved(productsInCollection)
}
